import React from 'react'
import contact from './contact.module.css'
import logo from '../../../Assets/Contact/contact.png'
import { NavLink } from 'react-router-dom'
import defaultIMG from "../../../Assets/defaultimg.png";
const Contactpage = () => {

    return (
        <div className={contact.Resource1_container}>
            <div className={contact.resource_container}>
                <h1 className={contact.header}>Contact Us</h1>
                <div className={contact["contact_subcontainer"]}>
                    <ul>
                        <li><NavLink to='/' className={({ isActive }) => isActive && contact.active}>Home</NavLink></li>
                        <span>|</span>
                        <li><NavLink to='/contactus' className={({ isActive }) => isActive && contact.active}>Contact Us</NavLink></li>
                    </ul>
                </div>
            </div>
            <div className={contact.resource_imagecontainer}>
                <img src={logo} 
                   onError={({ currentTarget }) => {
                    currentTarget.onerror = null; 
                    currentTarget.src= defaultIMG ;
                  }}
                alt='image' className={contact.resourceimg} />
            </div>
        </div>
    )
}
export default Contactpage